// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TAddOfferToComparisonRequest,
  TAddOfferToComparisonModel,
  IMappers,
  TAddOfferToComparisonResponse_,
  TAddOfferToComparisonResponse,
  TAddOfferToComparisonResponse_1,
  TAddOfferToComparisonResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createAddOfferToComparisonModel(parameters: TAddOfferToComparisonRequest): TAddOfferToComparisonModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'offers-comparison',
    pathApi: '/v2/add-offer-to-comparison/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IAddOfferToComparisonOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TAddOfferToComparisonRequest;
}

export async function fetchAddOfferToComparison<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddOfferToComparisonOptions<TResponse200, TResponse400>): Promise<
  TAddOfferToComparisonResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createAddOfferToComparisonModel(parameters),
    config,
  )) as FetchResponse<TAddOfferToComparisonResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TAddOfferToComparisonResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TAddOfferToComparisonResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TAddOfferToComparisonResponse;
}
